import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const FileUploadError = ({ className = '' }) => (
  <svg width="24" height="24" className={className}>
    <g fill="none" fillRule="evenodd">
      <g stroke={Colors.danger}>
        <path fill="#FFEFF1" d="M.5.5v22h16V4.207L12.793.5H.5z" />
        <path d="M12.5 0v4.5H17" />
      </g>
      <path
        fill={Colors.danger}
        d="M11.33 16.243l-2.828-2.828-2.83 2.828-1.414-1.415L7.087 12 4.258 9.172l1.415-1.415L8.5 10.586l2.828-2.829 1.415 1.415L9.915 12l2.829 2.828-1.415 1.415z"
      />
    </g>
  </svg>
);

FileUploadError.propTypes = {
  className: PropTypes.string
};

export default FileUploadError;
